import React from 'react';

/**
 * Imperative handle a question component can expose so validation can ask it
 * about state that isn't visible in the answer itself
 */
export type QuestionHandle = {
    // A partially entered native input (ex. a date with no year) reports an
    //  empty value, so the answer alone can't tell us the field is broken
    hasBadInput?: () => boolean;
};

export type QuestionRefRegistry = React.MutableRefObject<
    Record<string, React.RefObject<QuestionHandle>>
>;

export const QuestionRefContext = React.createContext<QuestionRefRegistry>({
    current: {},
});
